import { all, takeLatest, put, fork } from 'redux-saga/effects';
import {  authedApiSaga } from 'sagas';
import { postSubscription } from 'utils/api';
import { postSubscriptionSuccess, postSubscriptionError, resetSubscriptionError, togglePayinig } from './actions'
import { getSessionFlow } from 'containers/App/sagas';

export function* niceChoiceFlow({ payload }) {

  yield all ([
    put(togglePayinig()),
    authedApiSaga(postSubscription, [payload], postSubscriptionSuccess, [togglePayinig, postSubscriptionError])
    ]);
  yield put(resetSubscriptionError());
  yield fork(getSessionFlow);
}

export default function* watchNiceChoice() {
  yield all([
    takeLatest('NICE_CHOICE_REQUEST', niceChoiceFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/sagas.js